// extracted by mini-css-extract-plugin
module.exports = {"peopleInput":"_2nmw-m7TE9pgb9KPt1d8Re"};